module.exports = "<svg width=\"12\" height=\"8\" viewBox=\"0 0 12 8\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M.045 5.691a.49.49 0 0 0 .107.163l1.993 2a.495.495 0 0 0 .704 0 .501.501 0 0 0 0-.708L1.707 6h7.265a2.998 2.998 0 0 0 2.99-3V.5a.5.5 0 1 0-.997 0V3c0 1.103-.894 2-1.993 2H1.707l1.142-1.147a.501.501 0 0 0 0-.707.496.496 0 0 0-.704 0l-1.993 2a.5.5 0 0 0-.107.545z\" fill=\"#394F5A\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeSVGTagAttrs=false&removeTags=true!./src/images/svg/keys/return-key.svg
// module id = iv9e
// module chunks = 89